import {I18n} from '@aws-amplify/core';
import {BillingProvider,} from '../types';
import {
    PlatformEditPageGrid,
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardEntryInput,
    TabbedComponent,
    TabComponentTab,
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {StatusBadge} from "./StatusBadge.tsx";
import {IndexPage as PaymentProfilesPage} from "../../payment-profiles/pages/IndexPage.tsx";


export const Profile = ({record}: { record: BillingProvider }) => {

    const {allowedActions} = useVerifiedPermissions();
    const canUpdate = allowedActions.includes(rbacActions.UpdateBillingProvider);

    // ⚠️ Typed PlatformPropertyCardEntryInput[], never cast (§13). Under the old cast the
    // timestamps carried `formatAs: 'Timestamp'`, a key the card does not read, so Created
    // and Last Updated rendered as raw ISO strings and tsc could not see it.
    //
    // Created By uses the card's `person` formatter on createdByUser. It used
    // CreatedByProfileFormatter, which THROWS when createdByUsername is absent. Three of
    // the five providers on dev have none, and Flexi Network's detail page crashed on it.
    // "Updated By" is gone: it read `updatedBy`, which the API does not have.
    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Name'),
            value: record.name,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            emptyAs: 'dash',
            span: 12,
        }, {
            label: I18n.get('Description'),
            value: record.description,
            emptyAs: 'dash',
            span: 12,
        }, {
            label: I18n.get('Billing Provider Key'),
            value: record.key,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: I18n.get('Status'),
            value: <StatusBadge status={record.status}/>,
            span: 12,
        },
        canUpdate && {
            label: I18n.get('Created By'),
            value: record.createdByUser,
            formatter: 'person',
            emptyAs: 'dash',
            span: 12,
        },
        {
            label: I18n.get('Created'),
            value: record.created,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 12,
        },
        {
            label: I18n.get('Last Updated'),
            value: record.updated,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 12,
        }];

    const tabs = [
        {
            title: I18n.get('Payment Profiles'),
            component: <PaymentProfilesPage billingProviderId={record.id}/>,
        },
    ] as TabComponentTab[];

    return (
        <PlatformEditPageGrid
            leftContent={<PlatformPropertyCard properties={properties}/>}
            rightContent={<TabbedComponent tabs={tabs}/>}
        />
    );
};
